import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import api from '@/api'

import CreateEventAddBattle from '@/pages/CreateEventProcessingPage/ui/CreateEventAddBattle.vue'
import { BKConfirmationDialog } from '@/shared/ui/modals'
import EventEditActionButtons from '@/pages/CreateEventProcessingPage/ui/layout/EventEditActionButtons.vue'
import { mdiLeadPencil, mdiPlus, mdiTrashCanOutline } from '@mdi/js'
import { battleApi, BattleDB, useBattle } from '@/enitites/battle'
import { IEventEdit } from '@/enitites/event'
import { useQueryClient } from '@tanstack/vue-query'
import { eventKey } from '@/enitites/event/api/keys'
import { useSanitize } from '@/services/useSanitize'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventBattles',
  props: {
    eventData: null
  },
  emits: ["next", "back", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'next'): void
  (e: 'back'): void
  (e: 'cancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  eventData: IEventEdit
};

const { getBattleCategoryName } = useBattle()
const queryClient = useQueryClient()





const dialog = ref(false)
const currentBattleId = ref(0)
const loadingAddBtn = ref(false)
const errorMessage = ref<string>()
const confirmationDialog = ref({
  isShow: false,
  title: '',
  subtitle: '',
  confirmText: '',
  confirm: () => {},
})

function handleNext() {
  emit('next')
}

function handleCancel() {
  emit('cancel')
}

async function deleteBattle(battleId: number) {
  const resp = await api.battles.deleteBattle(battleId)
  if (resp) {
    queryClient.invalidateQueries({
      queryKey: eventKey.edit(props.eventData.id),
    })
  }
}

function confirmDeleteBattle(id: number) {
  confirmationDialog.value = {
    isShow: true,
    title: 'Delete',
    subtitle: 'Are you sure you want to delete this battle',
    confirmText: 'Delete',
    confirm: () => {
      deleteBattle(id)
      confirmationDialog.value.isShow = false
    },
  }
}

async function addBattle() {
  loadingAddBtn.value = true
  const battle = await battleApi.addBattle(props.eventData.id)
  loadingAddBtn.value = false

  const eventBattleChip = {
    id: battle.id,
    title: battle.title,
    crewSize: battle.crewSize,
    isLimitExceeded: battle.isLimitExceeded,
    isRegistered: false,
    limit: battle.limit,
    orgChip: {
      id: 0,
      name: '',
      image: '',
    },
  }

  if (battle) {
    // Update event data without direct mutation
    const updatedBattles = [...props.eventData.battles, eventBattleChip]
    queryClient.setQueryData(eventKey.edit(props.eventData.id), (oldData: IEventEdit | undefined) => {
      if (!oldData) return oldData
      return {
        ...oldData,
        battles: updatedBattles,
      }
    })
    currentBattleId.value = battle.id
    dialog.value = true
  }
}

const { sanitize } = useSanitize()

async function updateBattle(battle: BattleDB) {
  const mutatedBattle = { ...battle }
  if (mutatedBattle.description) {
    mutatedBattle.description = sanitize(battle.description)
  }
  const resp = await api.battles.update(mutatedBattle)
  if (resp) {
    const updatedBattles = props.eventData.battles.map((bat) =>
      bat.id === mutatedBattle.id ? { ...bat, title: mutatedBattle.title, crewSize: mutatedBattle.crewSize } : bat
    )
    queryClient.setQueryData(eventKey.edit(props.eventData.id), (oldData: IEventEdit | undefined) => {
      if (!oldData) return oldData
      return {
        ...oldData,
        battles: updatedBattles,
      }
    })
  }
}

function handlerClickEdit(battleId: number) {
  currentBattleId.value = battleId
  dialog.value = true
}

return { __sfc: true,getBattleCategoryName, queryClient, emit, props, dialog, currentBattleId, loadingAddBtn, errorMessage, confirmationDialog, handleNext, handleCancel, deleteBattle, confirmDeleteBattle, addBattle, sanitize, updateBattle, handlerClickEdit, CreateEventAddBattle, BKConfirmationDialog, EventEditActionButtons, mdiLeadPencil, mdiPlus, mdiTrashCanOutline }
}

})